import { chakra, Flex } from "@chakra-ui/react";
import Agreement from "@/pages/agreement/EnDoc";
import Privacypolicy from "@/pages/privacypolicy/EnDoc";

const Wrap = chakra(Flex, {
  baseStyle: {
    color: "#010313",
    flexDirection: "column",
    gap: "10px",
  },
});
const EnDc = () => {
  return (
    <Wrap>
      <Agreement />
      <Privacypolicy />
    </Wrap>
  );
};

export default EnDc;
